'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersSelectors, usersOperations } from '@/state/domains/users';

import { getWeekStartFromRef } from '@/state/utilities';

import Link from '@/views/common/Link';

import s from '../styles.scss';

export default connect(
	(state, props) => ({
		pageId: appSelectors.getPageId(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		loggedInUser: usersSelectors.getLoggedInUser(state, props),
		pageUser: usersSelectors.getPageUser(state, props),
	}),
	{}
)(
	({ loggedInUser, pageUser, urlParams, pageId }) => {

		const user = [ 'jobs', 'places', 'users' ].includes(pageId) ? loggedInUser : pageUser;

		if (!user) {
			return <div />;
		}

		let url = `/user/${ user.username }`;

		if ([ 'daily-route', 'daily-attempts', 'daily-location' ].includes(pageId)) {
			let d = new Date(urlParams.date + ' 00:00:00');
			let goDate = getWeekStartFromRef(user, d);
			url = `${ url }/${ goDate }`;
		}

		return (
			<Link to={{
					pathname: url,
				}}
			>
				Home
			</Link>
		);
	}
);
